import router from '@/router';
import i18n from '@/i18n';
import messageErreur from '@/services/general/messageErreur';

export function genererMessageEntityNotFound(erreur) {
  /* pas d'entité ([a-zA-Z]*)Entity avec id = ([a-zA-Z0-9-]*)! */
  const regex = /entité ([a-zA-Z]*)Entity/;
  const result = regex.exec(erreur?.data?.error?.message);
  return i18n.t('general.messages.error.entityNotFound', { entity: result[1] });
}

export function isEntityNotFound(erreur) {
  return erreur.status === 404 && erreur?.data?.error?.message?.includes('Il n\'y a pas d\'entité');
}

export function gestionEntityNotFound(e, routeRetour) {
  const isError = isEntityNotFound(e.response);
  if (isError) {
    messageErreur(i18n, genererMessageEntityNotFound(e.response));
    if (routeRetour !== undefined) {
      router.push(routeRetour);
    }
  }
  return isError;
}
